module.exports = __webpack_public_path__ + "static/media/TPP.8fc378e3.svg";